import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { LayoutProvider, LayoutSplashScreen } from '../theme/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import { Routes } from './routing/Routes'
import '../theme/i18n/i18nProvider';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { EventBusName } from './utils/common/constants'
import { EventBus } from './utils/helpers'
import { authActions } from './modules/auth'
import { useDispatch } from 'react-redux'
import { CreateOrderDrawer } from './modules/tickets/drawer/CreateOrderDrawer'
import { toggleDrawer as toggleDrawerCreateOrder } from 'app/modules/tickets/drawer/CreateOrderDrawer';
import { MapProvider } from '../providers/MapProvider'
type Props = {
  basename: string
}

const App: React.FC<Props> = ({ basename }) => {
  const dispatch = useDispatch();
  EventBus.getInstance().register(
    EventBusName.DOMAIN_NOT_SUPPORT,
    () => {
      toggleDrawerCreateOrder?.(false);
      dispatch(authActions.errorDomain());
    }
  )
  EventBus.getInstance().register(
    EventBusName.UNAUTHORIZED_REQUEST,
    () => {
      toggleDrawerCreateOrder?.(false);
      dispatch(authActions.logout());
      setTimeout(() => {
        document.location.reload();
      }, 100);
    }
  );
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      {/* @ts-ignore */}
      <BrowserRouter basename={basename}>
        <MapProvider>
          <LayoutProvider>
            <AuthInit>
              <Routes />
              <CreateOrderDrawer />
              <ToastContainer closeOnClick />
            </AuthInit>
          </LayoutProvider>
        </MapProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export { App }
